import React, { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DeviceTableHeaderResizeSlider from '../DeviceTableHeaderResizeSlider';
import { IconLoader } from 'common/IconLoader';
import { IconAndText } from 'components/shared/SvgAF/SvgAF';
import { handleSort } from 'redux/actions';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { DeviceHeaderCheckBox } from '../DeviceCheckBox';

const DeviceTableColumnHeader = (props) => {
  const dispatch = useDispatch();
  const activeTab = useSelector((store) => store.ui.devicesPage.activeTab);
  return (
    <div
      id="DeviceTable_Header_OuterDiv"
      className={classNames({
        DeviceTable_Header_OuterDiv: true,
        ...(props.customClassName && { [props.customClassName]: true })
      })}
      data-tip={props.text}
    >
      {!props.forAlarmMap && props.hasCheckbox && (
        <DeviceHeaderCheckBox
          devices={props.devices}
          hasCheckbox={props.hasCheckbox}
          deviceTableSet={props.deviceTableSet}
        />
      )}
      <IconAndText
        img={props.noSort ? null : IconLoader.icon_table_sort}
        hoverImg={props.noSort ? null : IconLoader.icon_table_sort_hover}
        text={props.text}
        reverse
        onClick={() => {
          props.sortName && dispatch(handleSort(activeTab, 'deviceTable', props.sortName));
        }}
      />
      {!props.forAlarmMap && props.hasResizeSlider && <DeviceTableHeaderResizeSlider />}
    </div>
  );
};

DeviceTableColumnHeader.propTypes = {
  customClassName: PropTypes.string,
  text: PropTypes.string,
  sortName: PropTypes.string,
  noSort: PropTypes.bool,
  hasResizeSlider: PropTypes.bool,
  forAlarmMap: PropTypes.bool,
  hasCheckbox: PropTypes.bool
};

DeviceTableColumnHeader.defaultProps = {
  customClassName: null,
  text: 'Unknown',
  sortName: null,
  noSort: false,
  hasResizeSlider: true,
  forAlarmMap: false,
  hasChecbox: false
};

export default memo(DeviceTableColumnHeader);
